module.exports = __webpack_public_path__ + "img/warning.31e53584.svg";